import {LoginComponent} from "./modules/auth/login/login.component";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {path: '', component: LoginComponent},
  {path: 'smart', loadChildren: () => import('./modules/smart-de/smart-de.module').then((m) => m.SmartDeModule)},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
